import type { ReactNode } from 'react';

export interface FieldProps {
  label?: string;
  /** 보조 설명 */
  hint?: string;
  /** 검증 에러 메시지 */
  error?: string;
  htmlFor?: string;
  children: ReactNode;
}

/** 라벨 + 입력 + 힌트/에러를 감싸는 폼 필드 래퍼 */
export default function Field({ label, hint, error, htmlFor, children }: FieldProps) {
  return (
    <div className="field">
      {label && (
        <label className="field__label" htmlFor={htmlFor}>
          {label}
        </label>
      )}
      {children}
      {error ? (
        <span className="field__error">{error}</span>
      ) : hint ? (
        <span className="field__hint">{hint}</span>
      ) : null}
    </div>
  );
}
